import { difference, get } from 'lodash';
import { createSelector } from 'reselect';

import DOMAIN_GROUPING_MESSAGES from './constants/domain-grouping-messages';
import { modalAttributesSelector } from '../../common/selectors/modal-selectors';
import { domainGroupFormStateSelector, domainGroupsByIdSelector } from '../../common/selectors/domain-groups-selectors';

export const modalDomainGroupIdSelector = createSelector(
    modalAttributesSelector,
    ( modalAttributes ) => {
        return get( modalAttributes, 'domainGroupId', null );
    }
);

export const modalDomainGroupNameSelector = createSelector(
    domainGroupFormStateSelector,
    ( formState ) => {
        return get( formState, 'name', '' );
    }
);

export const modalDomainsForAGroupSelector = createSelector(
    domainGroupFormStateSelector,
    ( formState ) => {
        return get( formState, 'domains', [] );
    }
);

export const modalPreselectedDomainsForAGroupSelector = createSelector(
    modalAttributesSelector,
    ( modalAttributes ) => {
        return get( modalAttributes, 'domains', [] );
    }
);

export const isEditDomainGroupSelector = createSelector(
    modalAttributesSelector,
    ( modalAttributes ) => {
        return get( modalAttributes, 'editMode', false );
    }
);

export const isAssigningDomainsToGroupSelector = createSelector(
    modalAttributesSelector,
    ( modalAttributes ) => {
        return get( modalAttributes, 'assignMode', false );
    }
);

export const isDomainGroupFormInvalidSelector = createSelector(
    domainGroupFormStateSelector,
    ( { name, domains, isDirty } ) => {
        return !name || !domains || !isDirty;
    }
);

export const domainGroupFormWarningSelector = createSelector(
    domainGroupsByIdSelector,
    domainGroupFormStateSelector,
    isAssigningDomainsToGroupSelector,
    ( existingGroupsMap, selectedGroup, assignMode  ) => {
        const existingGroup = existingGroupsMap[selectedGroup.id];
        let warnings = [];

        if( !selectedGroup ){
            return warnings;
        }

        // Case: adding preselected domains from a table to an existing group

        const isNewGroup = !selectedGroup.id;

        const allSelectedDomains = selectedGroup.domains || [];
        const existingDomains = get( existingGroup, 'domains', [] );

        // includes any preselected modal domains and additional domains selected on top of them that are not
        // already in the existing group
        const deltaDomainCount = difference( allSelectedDomains, existingDomains ).length;

        if( assignMode &&
        !isNewGroup &&
        deltaDomainCount > 0
        ){
            warnings.push( DOMAIN_GROUPING_MESSAGES.addingPreselected( deltaDomainCount, selectedGroup.name ) );
        }

        // Case: total selected domains > 25
        const selectedDomainCount = allSelectedDomains.length;
        const aboveThreshold = selectedDomainCount >= 25;

        if( aboveThreshold ){
            warnings.push( DOMAIN_GROUPING_MESSAGES.tooMany );
        }

        return warnings;
    }
);
